<template>
  <div class="row">
    <div class="col-md-12 overflow-auto" style="max-height: 400px">
      <ul id="itens" class="timeline">
        <li v-for="item in dados">
          <h3 v-html="`${item.status_exibicao} - ${item.data_cadastro_exibicao}`"></h3>
          <h5>{{ item.fase_exibicao }}</h5>
          <h5>{{ item.observacao }}</h5>
        </li>
      </ul>
    </div>
  </div>
  <br>
  <hr>
  <button class="btn btn-success font-bold" @click="$emit('fechar')">
    Fechar
  </button>
</template>

<script>
import {apiRequest} from "../../../public/js/utils/funcoes";
import {apiUrl} from "@/router/apiBackRoutes"

export default {
  name: 'HistoricoFase',
  props: {
    itemKey: String,
  },
  data() {
    return {
      dados: [],
    }
  },
  emits: ['fechar'],
  methods: {
    async getDados() {
      const resultado = await apiRequest("GET", `${apiUrl.analises.faseCreateList}?chave=${this.itemKey}`);
      if (resultado.success) {
        this.dados = resultado.data;
      } else {
        this.$toastMessage("warn", "Atenção", "Erro ao carregar registro!");
        console.error("Erro ao carregar:", resultado.error);
      }
    },
  },
  mounted() {
    this.getDados();
  }
}
</script>

<style>
ul.timeline {
  list-style-type: none;
  position: relative;
}
ul.timeline:before {
  content: ' ';
  background: #d4d9df;
  display: inline-block;
  position: absolute;
  left: 29px;
  width: 2px;
  height: 100%;
  z-index: 400;
}
ul.timeline > li {
  margin: 30px 0;
  padding-left: 20px;
}
ul.timeline > li:before {
  content: ' ';
  background: white;
  display: inline-block;
  position: absolute;
  border-radius: 50%;
  border: 3px solid #22c0e8;
  left: 20px;
  width: 20px;
  height: 20px;
  z-index: 400;
}
</style>
